module.exports = __webpack_public_path__ + "img/nextstep.e2d8c1a7.png";